import { all, fork } from "redux-saga/effects";
import userSaga from "../redux/User/UserSaga"
import projectSaga from "../redux/Projects/ProjectsSaga"
import AdminSaga from "./Admin/AdminSaga";

export default function* rootSaga() {
  yield all([fork(userSaga), fork(projectSaga), fork(AdminSaga)]);
}
